var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    {
      'owc-text-media-module--text-only-offset': _vm.shouldAddOffsetToText,
      'owc-text-media-module--dark': _vm.isDarkModeOn,
      'owc-wb-accordion-content': _vm.isPartOfAccordion,
    },
    'owc-text-media-module',
  ]},[(_vm.isEditMode)?_c('ValidationBoxWrapper',[_vm._t("validation-box",null,{"slot":"validation-box"})],2):_vm._e(),_c('div',{staticClass:"owc-text-media-module__container wb-grid-container"},[_c('div',{staticClass:"owc-text-media-module__row wb-grid-row",class:[
        {
          'owc-text-media-module__row--inverted': _vm.isTextOnLeft,
        },
        'owc-text-media-module__row',
        'wb-grid-row',
      ]},[_c('div',{class:[
          {
            'wb-grid-col-offset-mq3-1': !_vm.isTextOnLeft && _vm.isMediaContainer,
          },
          // Full width when there is no media block
          _vm.isMediaContainer ? 'wb-grid-col-mq3-5' : 'wb-grid-col-mq3-12',
          'owc-text-media-module__text-block',
          'wb-grid-col-mq1-12',
        ]},[(_vm.personaliseableData.textBlock)?_c('TextBlock',{attrs:{"textBlockData":_vm.textBlock,"hasHeadline":_vm.hasHeadline,"containsMedia":_vm.isMediaContainer,"darkMode":_vm.isDarkModeOn}}):_vm._e(),(_vm.isCTAVisible)?_c('Cta',{staticClass:"owc-text-media-module__cta-button",attrs:{"ctaData":_vm.buttonData,"darkMode":_vm.isDarkModeOn}}):_vm._e()],1),(_vm.isMediaContainer)?_c('div',{class:[
          {
            'wb-grid-col-offset-mq3-1': _vm.isTextOnLeft,
          },
          'wb-grid-col-mq1-12',
          'wb-grid-col-mq3-6',
        ]},[_c('div',{class:[
            {
              'owc-text-media-module__media--inverted': _vm.isTextOnLeft,
              'owc-text-media-module__author': _vm.isEditMode,
            },
            'owc-text-media-module__media',
          ]},[_c('div',{staticClass:"owc-text-media-module__media-content"},[(_vm.isEditMode)?_c('SlotContainer',{staticClass:"owc-text-media-module__slider",attrs:{"refName":"slot-textMediaModuleItem","theme":_vm.theme}},[_vm._t("default")],2):[_c('wb-slider',{attrs:{"show-dot-navigation":"","theme":_vm.theme}},[_c('template',{ref:"wbSlider",tag:"SlotContainer",attrs:{"refName":"slot-textMediaModuleItem"}},[_vm._t("default")],2)],1)]],2)])]):_vm._e(),_c('div',{staticClass:"wb-grid-col-mq1-12"},[(_vm.isCTAVisible)?_c('Cta',{staticClass:"owc-text-media-module__cta-button owc-text-media-module__cta-button--mobile",attrs:{"ctaData":_vm.buttonData,"darkMode":_vm.isDarkModeOn}}):_vm._e()],1)])]),(_vm.footnotes)?_c('div',{staticClass:"wb-grid-container owc-text-media-module__footnotes"},[_c('Footnotes',{attrs:{"footnotesData":_vm.footnotes}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }